import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask } from '@myplay/ui';
import { inject, observer } from "mobx-react";

import I18N from '../../I18N';
import { toTitleCase } from '../../utils/stringManipulations';
import AddTeamInputsPanel from './AddTeamInputsPanel';
import ButtonsPanel from './ButtonsPanel';
import './AddTeamModal.scss';

class AddTeamModal extends Component {

  static propTypes = {
    closeModal: PropTypes.func,
    isEditTeam: PropTypes.bool,
    isVisible: PropTypes.bool
  };

  static defaultProps = {
    closeModal: () => { },
    isEditTeam: false,
    isVisible: false
  };

  state = {
    selectedCategory: {},
    selectedSite: {},
    selectedSeason: {},
    newTeamName: "",
    selectedTeamId: ""
  };

  componentDidUpdate(prevProps) {
    const { TeamsStore: { selectedTeam }, isEditTeam } = this.props;
    const { selectedTeamId } = this.state;
    if (isEditTeam && selectedTeamId !== selectedTeam._id) {
      const { name, year, site, category } = selectedTeam;
      this.setState({
        selectedCategory: category,
        selectedSite: site,
        selectedSeason: year,
        newTeamName: name,
        selectedTeamId: selectedTeam._id
      });
    };
    if (!isEditTeam && prevProps.isEditTeam !== isEditTeam) {
      this.setState({
        selectedCategory: {},
        selectedSite: {},
        selectedSeason: {},
        newTeamName: "",
        selectedTeamId: ""
      });
    }
  }

  handleChangeTeamName = name => {
    this.setState({
      newTeamName: name
    })
  };

  handleSelectSite = site => {
    this.setState({
      selectedSite: site
    });
  };

  handleSeasonSelect = season => {
    this.setState({
      selectedSeason: season.value
    });
  }


  handleSportSelect = sport => {
    this.setState({
      // selectedCategory: sport.name
      selectedCategory: sport
    });
  };

  handleSave = async () => {
    const { TeamsStore: { createNewTeam, updateTeamDetails }, closeModal, isEditTeam } = this.props;
    const { newTeamName, selectedSite, selectedCategory, selectedSeason } = this.state;
    const newTeam = {
      name: newTeamName,
      connectedSiteId: selectedSite ? selectedSite._id : null,
      category: selectedCategory.name,
      year: selectedSeason
    }
    if (!isEditTeam) {
      await createNewTeam(newTeam);
    } else {
      await updateTeamDetails(newTeam)
    }
    closeModal();
  }

  handleDiscard = () => {
    const { closeModal } = this.props;
    this.setState({
      selectedCategory: {},
      selectedSite: {},
      selectedSeason: {},
      newTeamName: ""
    });
    closeModal();
  }

  render() {
    const { isVisible, isEditTeam } = this.props;
    const { newTeamName, selectedSite, selectedCategory, selectedSeason } = this.state;
    return (
      <DarkScreenMask isVisible={isVisible}>
        <div className="add-team-modal" data-testid="add-team-modal">
          <span className="add-team-modal__title">
            {toTitleCase(!isEditTeam ? I18N.t("ADD_NEW_TEAM") : I18N.t("EDIT_TEAM"))}
          </span>
          {isVisible &&
            <AddTeamInputsPanel
              onChangeName={this.handleChangeTeamName}
              onSelectSite={this.handleSelectSite}
              teamName={newTeamName}
              onSelectSeason={this.handleSeasonSelect}
              onSportSelect={this.handleSportSelect}
              selectedSite={isEditTeam ? selectedSite : null}
              selectedCategory={isEditTeam ? selectedCategory : null}
              selectedSeason={isEditTeam ? selectedSeason : null}
            />
          }
          <ButtonsPanel onDiscard={this.handleDiscard} onSave={this.handleSave} />
        </div>
      </DarkScreenMask>
    )
  }
};

export default inject("TeamsStore")(observer(AddTeamModal));